module.exports = __webpack_public_path__ + "static/media/slider05.7629a5d8.jpg";